import { OrderType } from 'graphql-api/gql-api-interfaces';

import { BusinessState, DeliveryPeriodType, UiState } from '../../../models';
import { getDeliveryShopKey } from '../../../shared/shared';
import { updateShopsWithFutureDeliveryPeriod } from '../update-shops-with-new-selected-delivery-period/update-shops-with-future-delivery-period';

export function selectFutureDeliveryPeriodBusiness(
  state: BusinessState,
  { deliveryPeriod: { from } }: { deliveryPeriod: { from: string | null } },
): BusinessState {
  const deliveryShopId = getDeliveryShopKey(state.activeDeliveryShop);
  const deliveryPeriodsByShop = state.deliveryPeriods[deliveryShopId] ?? {};
  const deliveryPeriodsByType =
    deliveryPeriodsByShop[DeliveryPeriodType.Future] ?? {};
  const shopAndTypeDeliveryPeriods =
    deliveryPeriodsByType.deliveryPeriods ?? [];

  if (!!from) {
    const nextSelectedDeliveryPeriod = shopAndTypeDeliveryPeriods?.find(
      (deliveryPeriod: string) => deliveryPeriod === from,
    );

    if (!nextSelectedDeliveryPeriod) {
      return state;
    }

    return {
      ...state,
      deliveryPeriods: updateShopsWithFutureDeliveryPeriod(
        state.deliveryPeriods ?? {},
        nextSelectedDeliveryPeriod,
      ),
    };
  }

  return {
    ...state,
    deliveryPeriods: {
      ...state.deliveryPeriods,
      [deliveryShopId]: {
        ...deliveryPeriodsByShop,
        currentDeliveryPeriodType: DeliveryPeriodType.Future,
      },
    },
  };
}

export function selectFutureDeliveryPeriodUi(state: UiState): UiState {
  return {
    ...state,
    selectedOrderType: OrderType.Future,
  };
}
